import { render } from "./modify-tournament.template.html?vue&type=template&id=57b16063&scoped=true"
import script from "./ModifyTournament.vue?vue&type=script&lang=ts"
export * from "./ModifyTournament.vue?vue&type=script&lang=ts"

import "./ModifyTournament.vue?vue&type=style&index=0&id=57b16063&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57b16063"

export default script